import { EdgeListItemTodosRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListItemTodos } from '@/shared/domain/use-cases'

export function makeListItemTodos(): ListItemTodos {
  return new EdgeListItemTodosRepository(makeSupabaseEdgeHttpClient()).execute
}
